module.exports = __webpack_public_path__ + "img/delete.64cc9ea9.svg";